import updateQueryParameters from './updateQueryParameters';
import replaceRoute from './replaceRoute';

const getBrandsBySelected = (
  filters,
  brands,
  queryParameters,
) => brands.map(({ name, id }) => ({
  name,
  id,
  onChange: (event) => {
    replaceRoute(
      'products',
      updateQueryParameters(
        queryParameters,
        filters,
        'brandIds',
        id,
        event.target.checked,
      ),
    );
  },
}));

export default getBrandsBySelected;
